export const widgetSearchParamKeys = {
  indicator: 'indicator',
};

export const widgetPaths = {
  searchAsset: 'searchAsset',
  watchlistManagerModal: 'watchlistManagerModal',
} as const;

export type WidgetPathNames = (typeof widgetPaths)[keyof typeof widgetPaths];
